import isEqual from 'lodash/isEqual';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { collectionActions, collectionSelectors } from 'redux/collection';

// One request per page returns every collection attached to it, already scoped
// to what the member may see. The flag is undefined until the page has loaded,
// and asking anyway answers 403 on workspaces without the collections feature.
const usePageCollections = (pageId, hasCollections) => {
  const dispatch = useDispatch();

  const getPageCollections = useSelector(collectionSelectors.getPageCollectionsSelector, isEqual);

  useEffect(() => {
    if (pageId && hasCollections) {
      dispatch(collectionActions.getPageCollections({ pageId }));
    }
  }, [dispatch, pageId, hasCollections]);

  return getPageCollections(pageId);
};

export default usePageCollections;
